/**
 * Created by mqamhieh on 6/26/16.
 */
(function (app) {

    var TYPES = {
        NO_ACTION: -1,
        DRAG: 1,
        RESIZE: 2,
        CREATE: 3,
        OPTIONS: 4,
        CLICK: 5,
        LEFT_CLICK: 6,
        COPY: 7,
        SHIFT_TEMPLATE_DROP: 8,
        SHIFT_DETAILS_CLICKED: 9,
        JOB_TITLE_SLOT: 10,
        HOVER: 11,
        ROW_OPTIONS: 12,
    };

    var EVENTS = {
        SLOT_UPDATED: 'updated',
        SLOT_CREATED: 'created',
        SLOT_RESIZED: 'resized',
        SLOT_MOVED: 'moved',
        SLOT_OPTIONS: 'options',
        SLOT_CLICKED: 'clicked',
        SLOT_HOVER: 'slot_hover',
        ROWS_UPDATED: 'rows_up',
        ROW_CLICKED: 'row_clicked',
        ROW_RIGHT_CLICK: 'row_right_click',
        ADD_CLICKED: 'add_clicked',
        ADD_NOTES_CLICKED: 'add_notes_clicked',
        ADD_DAY_NOTES_CLICKED: 'add_day_notes_clicked',
        ROW_REMOVE: 'row_remove',
        ROW_PUBLISH: 'row_publish',
        ROW_CLEAR: 'row_clear',
        VIEW_GFE: 'view_gfe',
        AUTO_ASSIGN_WITH_GFE: 'auto_assign_with_gfe',
        DROPDOWN_CLICKED: 'dropdown_clicked',
        USER_CLICKED: 'user_clicked',
        DAY_CLICKED: 'day_clicked',
        ALL_CLICKED: 'all_clicked',
        SLOT_CHECK_CHANGED: 'slot_checked',
        EDITS_LOCKED: 'edits_locked',
        REMOVE_JOB_TITLE_SLOT : 'remove-job-title-slot',
        ADD_SHIFT_BTN_CLICKED: 'add_shift_btn_clicked',
        FORECASTED_HOURS_CLICKED: 'forecasted_hours_clicked',
    };

    var SchedulerDragDropService = function (viewService) {
        var self = this;
        var _activeViewService = viewService;
        var action;
        var emitter;
        var stopRowClick;
        emitter = JarEventEmitter.call(self);
        var createAction = function (type, event) {

            var newAction = {};
            const scheduleTables = $('.schedule-tables');

            newAction['type'] = $(event.currentTarget).parents(".slot").attr("prevent-actions") === 'ALL' ? TYPES.NO_ACTION : type;
            newAction['offsetX'] = 0;
            newAction['offsetY'] = 0;
            newAction['startX'] = event.pageX;
            newAction['startY'] = event.pageY + scheduleTables.scrollTop();

            if ([TYPES.CREATE, TYPES.CLICK, TYPES.SHIFT_TEMPLATE_DROP, TYPES.HOVER, TYPES.ROW_OPTIONS].indexOf(type) > -1) {
                newAction['target'] = $(event.target);

                if (!newAction['target'].hasClass("slots-row")) {
                    newAction['target'] = newAction['target'].parents(".slots-row");
                }

                newAction['rowIndex'] = newAction['target'].index();
                newAction['itemIndex'] = newAction['target'].parents(".item").index();
                newAction['scheduleIndex'] = newAction['target'].parents(".the-schedule").data('index');
                newAction['elmStartX'] = (event.pageX - newAction['target'].offset().left) - ((event.pageX - newAction['target'].offset().left) % _activeViewService.stepSize);
                newAction['elmStartY'] = 0;
                newAction['startOffset'] = parseInt(newAction['elmStartX'] / _activeViewService.stepSize);

                if (type == TYPES.SHIFT_TEMPLATE_DROP) {
                    newAction['shiftTemplateCode'] = event.dataTransfer.getData("text");
                }
            } else if (type == TYPES.SHIFT_DETAILS_CLICKED) {
                newAction['target'] = $(event.target).parents(".shift-details");
                newAction['slotId'] = newAction['target'].data('id');
                newAction['slotType'] = newAction['target'].data('slot-type');
            } else {
                newAction['target'] = $(event.currentTarget).parents(".slot");
                var container = newAction['target'].parent();
                var row = newAction['target'].parents(".slots-row");
                var item = newAction['target'].parents(".item");
                var schedule = newAction['target'].parents(".the-schedule");
                var slot = newAction['target'];

                newAction['slotIndex'] = slot.index();
                newAction['rowIndex'] = row.index();
                newAction['itemIndex'] = item.index();
                newAction['scheduleIndex'] = newAction['target'].parents(".the-schedule").data('index');

                newAction['elmStartX'] = parseInt(newAction['target'].css("left"));
                newAction['elmStartY'] = parseInt(newAction['target'].css("top"));

                newAction['startWidth'] = newAction['target'].width();

                if (slot.data("slot-code")) {
                    newAction['shiftTemplateCode'] = slot.data("slot-code");
                }

                if (type == TYPES.COPY) {
                    // If the action is COPY, then duplicate the slot
                    newAction['target'] = newAction['target'].clone();
                    newAction['target'].addClass("copy");
                    newAction['target'].find(".warnings").hide();
                    container.append(newAction['target']);
                }

                if (type != TYPES.OPTIONS && type !=  TYPES.JOB_TITLE_SLOT) {
                    newAction['target'].addClass("in-action");
                }

                newAction['target'].addClass("active-action");
                container.addClass("active-action");
                container.parent().addClass("active-action");
            }

            newAction['id'] = newAction['target'].parents(".the-schedule").attr("id");
            return newAction;
        };

        var onSlotRightMenu = function (event) {

            if (_activeViewService.isLocked && (!_activeViewService.canPublish || $(event.target).parents('.slot').data('status') == 'PUBLISHED')) {
                event.preventDefault();
                event.stopImmediatePropagation();
                emitter.triggerSync(EVENTS.EDITS_LOCKED);
                return;
            }

            var optionsAction = createAction(TYPES.OPTIONS, event);
            emitter.trigger(EVENTS.SLOT_OPTIONS, optionsAction);
            return false;
        };

        var onShiftDetailsLeftClick = function (event) {
            if ($(event.target).hasClass("select-shift")) {
                var shiftDetails = $(event.target).parents(".shift-details");
                var rowElm =  $(event.target).parents(".item-row");
                var scheduleElm = rowElm.parents(".the-schedule");
                var rowElmId = rowElm.data('id');

                if (_activeViewService.checkWithinEmploymentPeriod(createAction(TYPES.LEFT_CLICK, event), "EDIT", true)) {
                    emitter.trigger(EVENTS.SLOT_CHECK_CHANGED, event, parseInt(shiftDetails.data("id")), shiftDetails.find(".select-shift").is(":checked"));
                }
            } else if ($(event.target).hasClass("edit-shift-details-btn")) {
                var optionsAction = createAction(TYPES.SHIFT_DETAILS_CLICKED, event);
                emitter.trigger(EVENTS.SLOT_CLICKED, optionsAction);
            }
        };

        var onSlotLeftClick = function (event) {
            if ($(event.target).hasClass("copy-input")) {
                var itemElm = $(event.target).parents(".item");
                var slotElm = $(event.target).parents(".slot");
                var scheduleElm = itemElm.parents(".the-schedule");
                var itemElmIndex = itemElm.index();

                // Handle the status of Row Check (when all slot are NOT checked)
                if (itemElm.find(".slot .copy-input:checked").length == 0) {
                    scheduleElm.find(".item-row:eq(" + itemElmIndex + ") .row-copy.copy-input:checked").click();
                }

                // Handle the status of Row Check (when all slot are checked)
                if (itemElm.find(".slot .copy-input:not(:checked)").length == 0) {
                    scheduleElm.find(".item-row:eq(" + itemElmIndex + ") .row-copy.copy-input:not(:checked)").click();
                }

                // Handle the status of Schedule Check (when all slot are NOT checked)
                if (scheduleElm.find(".slot .copy-input:checked").length == 0) {
                    scheduleElm.find(".copy-input.schedule-copy:checked").click();
                }

                // Handle the status of Schedule Check (when all slot are checked)
                if (scheduleElm.find(".slot .copy-input:not(:checked)").length == 0) {
                    scheduleElm.find(".copy-input.schedule-copy:not(:checked)").click();
                }


                if (_activeViewService.checkWithinEmploymentPeriod(createAction(TYPES.LEFT_CLICK, event), "EDIT", true))  {
                    emitter.trigger(EVENTS.SLOT_CHECK_CHANGED, event, parseInt(slotElm.attr("id")), slotElm.find(".copy-input").is(":checked"));
                }

            }
            else if (!stopRowClick &&
                $(event.currentTarget).hasClass("slot-content")) {
                var optionsAction = createAction(TYPES.LEFT_CLICK, event);
                emitter.trigger(EVENTS.SLOT_CLICKED, optionsAction);
                return false;
            }
        };

        var isRightClick = function (event) {

            var isRightClick = false;

            if ("which" in event) {
                isRightClick = (event.which == 3);
            }
            else {
                isRightClick = (event.button == 2);
            }

            return isRightClick;
        };

        var slotDragHandler = function (event) {
            var newAction = createAction(TYPES.CLICK, event);
            var isShiftLocked = _activeViewService.isShiftBeforeCurrentBrandTimezone(newAction);
            $('.add-shift-btn').remove();

            if (!isRightClick(event)) {
                if (!action) {

                    if (_activeViewService.isLocked || isShiftLocked || $(event.currentTarget).parents(".slot").attr("prevent-actions") === 'ALL') {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        return;
                    }

                    // Check Cmd button is pressed on Mac, and Ctrl on other devices (windows, linux)
                    var isCtrlCmdPressed = (navigator.platform.indexOf("Mac") == 0 && event.metaKey) || (navigator.platform.indexOf("Mac") == -1 && event.ctrlKey);

                    if (isCtrlCmdPressed) {
                        action = createAction(TYPES.COPY, event);
                        $("body").addClass('copy');
                    }
                    else {
                        action = createAction(TYPES.DRAG, event);
                        $("body").addClass('drag');
                    }

                    if (action['target'].hasClass("saving") || action['target'].hasClass("locked")) {
                        action = null;
                        event.preventDefault();
                        event.stopPropagation();

                    }

                }
            }
        };

        var slotResizeLeftHandler = function (event) {

            if (_activeViewService.isLocked) {
                event.preventDefault();
                event.stopImmediatePropagation();
                return;
            }

            if (!isRightClick(event)) {
                if (!action) {
                    action = createAction(TYPES.RESIZE, event);

                    if (action['target'].hasClass("saving") || action['target'].hasClass("template-slot")) {
                        action = null;
                        event.preventDefault();
                        event.stopPropagation();
                        return;
                    }

                    action['direction'] = 'left';
                    $("body").addClass('resizeLeft');
                }
            }
        };

        var slotResizeRightHandler = function (event) {

            if (_activeViewService.isLocked) {
                event.preventDefault();
                event.stopImmediatePropagation();
                return;
            }

            if (!isRightClick(event)) {
                if (!action) {
                    action = createAction(TYPES.RESIZE, event);

                    if (action['target'].hasClass("saving") || action['target'].hasClass("template-slot")) {
                        action = null;
                        event.preventDefault();
                        event.stopPropagation();
                        return;
                    }

                    action['direction'] = 'right';
                    $("body").addClass('resizeRight');
                }
            }
        };

        var revertAction = function() {

            if (action.type === TYPES.COPY) {
                action.target.remove();
            } else {
                _activeViewService.revertSlotUI(action);
            }
        };

        var doActualResize = function () {
            var sizeChange;
            var offsetShift;

            if (action['direction'] == 'right') {
                sizeChange = action.offsetX / _activeViewService.stepSize;
            }
            else {
                offsetShift = Math.floor(action.offsetX / _activeViewService.stepSize);
            }

            var from = {
                itemIndex: action['itemIndex'],
                rowIndex: action['rowIndex'],
                slotIndex: action['slotIndex'],
                scheduleIndex: action['scheduleIndex']
            };

            _activeViewService.resizeSlot(action, from, offsetShift, sizeChange);
            emitter.triggerSync(EVENTS.SLOT_RESIZED, $.extend({}, action));

        };

        var doActualShiftTemplateDrop = function (action) {
            var from = {
                itemIndex: action['itemIndex'],
                rowIndex: action['rowIndex'],
                slotIndex: action['slotIndex'],
                scheduleIndex: action['scheduleIndex']
            };

            var offset = Math.floor(action.elmStartX / _activeViewService.stepSize);

            if (_activeViewService.isAllowed(null, from, action)) {
                _activeViewService.createSlotFromTemplate(action, from, offset);
                emitter.triggerSync(EVENTS.SLOT_CREATED, $.extend({}, action));
            }
            else {
                action = null;
            }
        };

        var doActualCreate = function () {

            var offset, size;

            if (action['direction'] == 'right') {
                offset = Math.floor(action.elmStartX / _activeViewService.stepSize);
                size = Math.abs(1 + (action.offsetX / _activeViewService.stepSize));
            }
            else {
                size = Math.abs((action.offsetX / _activeViewService.stepSize)) + 1;
                offset = (Math.ceil(action.elmStartX / _activeViewService.stepSize) - size) + 1;
            }

            var from = {
                itemIndex: action['itemIndex'],
                rowIndex: action['rowIndex'],
                slotIndex: action['slotIndex'],
                scheduleIndex: action['scheduleIndex']
            };

            action.slotIndex = from.slotIndex;
            _activeViewService.createSlot(action, from, offset, size);

            emitter.triggerSync(EVENTS.SLOT_CREATED, $.extend({}, action));

        };

        var runWarningsPopOverHandler = function (action, element) {
            if (!action) {
                var rowsWarningsPopOver = $(".rowsWarningsPopOver");
                const parentSchedule = element.parents(".schedule_v2");
                rowsWarningsPopOver.css("right", parentSchedule.width() + parentSchedule.offset().left - element.offset().left + 10);
                rowsWarningsPopOver.css("top", element.offset().top - element.parents(".schedule_v2").offset().top - 20);

                var rowId = parseInt(element.attr("id"));
                var scheduleId = element.parents(".the-schedule").attr("id");

                rowsWarningsPopOver.html("");
                rowsWarningsPopOver.hide();

                _activeViewService.getRowWarningHTML(scheduleId, rowId)
                    .then(function ({html, formattedWarnings}) {
                        rowsWarningsPopOver.html(html);
                        rowsWarningsPopOver.find('[data-fix-with-ai]').on('click', async function (event) {
                            const data = this.dataset;
                            const ScheduleWarningServiceV2 = $injector.get('ScheduleWarningServiceV2');
                            const autoSchedulingService = $injector.get('autoSchedulingService');
                            const scheduleDataServiceV2 = $injector.get('ScheduleDataServiceV2');
                            const warning = ScheduleWarningServiceV2.prepareWarning(formattedWarnings[data.userId][data.warningCategory][data.fixWithAi]);
                            const genAiService = $injector.get('genAiService');

                            const streamingMessage = genAiService.initStreamingMsg();

                            if (warning['shift']) {
                                const shift = scheduleDataServiceV2.flatData['shifts'][warning['shift'].id];

                                const users = await autoSchedulingService.getEligibleUsers(shift, {
                                    type: _activeViewService.viewType,
                                    day: _activeViewService.selectedDate
                                });

                                warning['suggested_employees'] = users.map((item) => {
                                    return {
                                        shift_match_score: item['score'],
                                        display_name: item.user['display_name'],
                                        id: item.user['id'],
                                        has_approved_unavailability: item['isUnavailable'],
                                        requested_unavailability: item['requestedUnavailability'],
                                        alreadyScheduledSameDay: !!item['alreadyScheduledSameDay'],
                                    }
                                });

                                warning['suggested_employees'].length = 1;
                            }

                            genAiService.sendMessage('FE_SYSTEM', '', 'REQUEST_FIX_OPTIONS', {warning_to_resolve: {...warning}}, streamingMessage);
                        });
                        rowsWarningsPopOver.show();
                    });
            }
        };

        var runAddShiftBtnHandler = function (event) {
            var target = $(event.target).parents(".slot");
            var slotId = target.attr("id");

            if (_activeViewService.CONSTANTS['SCHEDULES_CONTAINER_SELECTOR'] === '#schedulers-job-titles' ||
                !slotId ||
                _activeViewService.isLocked ||
                stopRowClick
            ) {
                return;
            }

            const newAction = createAction(TYPES.HOVER, event);

            if (!_activeViewService.checkWithinEmploymentPeriod(newAction, "CREATE") ||
                _activeViewService.isShiftBeforeCurrentBrandTimezone(newAction)) {
                return;
            }

            var addShiftIcon = $(`<div class="add-shift-btn px-1 no-print" title="Add new shift" id="add_shift_btn_${slotId}">
                <i class="fa fa-plus"></i>
            </div>`);

            addShiftIcon.on("mousedown", (event) => {
                event.stopPropagation();
            });

            addShiftIcon.off("click").on("click", function (event) {
                event.stopPropagation();
                emitter.trigger(EVENTS.ADD_SHIFT_BTN_CLICKED, createAction(TYPES.CLICK, event));
            });

            emitter.triggerSync(EVENTS.SLOT_HOVER, $.extend({}, newAction), slotId, addShiftIcon);
        };

        let warningsPopOverTimer;

        var offWarningsPopOverHandler = function () {
            var enterWarningsPopOver = $(".rowsWarningsPopOver:hover").length > 0;
            var insideWarningCell = $(".warning:hover").length > 0;

            clearTimeout(warningsPopOverTimer);
            warningsPopOverTimer = setTimeout(function () {
                if (!enterWarningsPopOver && !insideWarningCell) {
                    $(".rowsWarningsPopOver").hide();
                }
            }, 2000);
        };

        let onScheduleCalendarHover = (event, element) => {
            if (!action) {
                const scheduleCalendarTooltip = $(".scheduleCalendarTooltip");
                let left = 18 + element.offset().left - element.parents(".schedule_v2").offset().left;

                const scheduleCalendarTooltipOverRightEdge = left + scheduleCalendarTooltip.outerWidth();
                const windowWidth = $(window).width();

                if (scheduleCalendarTooltipOverRightEdge > windowWidth) {
                    left -= scheduleCalendarTooltip.outerWidth() + 20;
                }

                scheduleCalendarTooltip.css("left", left);
                scheduleCalendarTooltip.css("top", element.offset().top - element.parents(".schedule_v2").offset().top - 5);

                scheduleCalendarTooltip.html("");

                const html = _activeViewService.getScheduleCalendarTooltipHTML(event);
                scheduleCalendarTooltip.html(html);
                scheduleCalendarTooltip.show();
            }
        }

        var doActualMove = function(copy) {
            if (action['offsetX'] || action['offsetY']) {

                var rowsShift = action['stepsY'];
                var scheduleElm = action.target.parents(".the-schedule");

                var to;
                var from = {
                    itemIndex: action['itemIndex'],
                    rowIndex: action['rowIndex'],
                    slotIndex: action['slotIndex'],
                    scheduleIndex: action['scheduleIndex']
                };
                var isWithinEmploymentPeriod = _activeViewService.checkWithinEmploymentPeriod(createAction(TYPES.CLICK, event), "CREATE");

                if (rowsShift != 0) {
                    var fromRowIndex = action.target.parent().index("#" + scheduleElm.attr("id") + " .slots-row");
                    var toRowIndex = fromRowIndex + rowsShift;

                    var toRow = action.target.parents(".the-schedule").find(".slots-row")[toRowIndex];

                    if (toRow ) {
                        to = {
                            itemIndex: $(toRow).parent().index(),
                            rowIndex: $(toRow).index(),
                            slotIndex: 0,
                            scheduleIndex: action['scheduleIndex']
                        };

                        // Check if actions is allowed, (available positions and users to the target row match the slot position and user)
                        if (_activeViewService.isAllowed(from, to, action)) {
                            var moveCallback = function (action, toRow) {
                                action.target.css("top", "");
                                action.target.detach().appendTo(toRow);
                            };

                            var shiftInfo = {
                                action: action,
                                from: from,
                                to: to
                            };

                            if (
                                isWithinEmploymentPeriod &&
                                _activeViewService.showShiftDeleteConfirmationModal &&
                                _activeViewService.showShiftDeleteConfirmationModal(shiftInfo) &&
                                !copy
                            ) {
                                _activeViewService.openShiftDeleteConfirmationModal(shiftInfo, moveCallback, toRow);
                                return;
                            } else {
                                action.target.css("top", "");
                                action.target.detach().appendTo(toRow);
                            }
                        }
                        else {
                            if (copy) {
                                // In case of invalid copy, just remove the new copied element
                                action.target.remove();
                            }
                            else {
                                revertAction();
                            }
                            return;
                        }
                    }
                    else {
                        revertAction();
                        emitter.trigger(EVENTS.SLOT_UPDATED, $.extend({}, action));
                        return;
                    }
                }
                else {
                    to = from;

                    if (_activeViewService.isAllowed(from, to, action)) {
                        var shiftInfo = {
                            action: action,
                            from: from,
                            to: to
                        };

                        if (
                            isWithinEmploymentPeriod &&
                            _activeViewService.showShiftDeleteConfirmationModal &&
                            _activeViewService.showShiftDeleteConfirmationModal(shiftInfo) &&
                            !copy
                        ) {
                            _activeViewService.openShiftDeleteConfirmationModal(shiftInfo);
                            return;
                        }
                    } else {
                        if (copy) {
                            action.target.remove();
                        }
                        else {
                            revertAction();
                        }
                        return;
                    }
                }

                // renderData.dataService.shiftSlot(from, (action['offsetX'] / renderData['SLOT_WIDTH']));
                // var newSlotIndex = renderData.dataService.moveSlot(from, to);

                action['itemIndex'] = to['itemIndex'];
                action['rowIndex'] = to['rowIndex'];
                if (isWithinEmploymentPeriod) {
                    if (copy) {
                        emitter.triggerSync(EVENTS.SLOT_CREATED, $.extend({}, action));
                        _activeViewService.moveSlot(action, from, to, true);
                    } else {
                        emitter.triggerSync(EVENTS.SLOT_MOVED, $.extend({}, action));
                        _activeViewService.moveSlot(action, from, to);
                    }
                } else {
                    action['itemIndex'] = from['itemIndex'];
                    action['rowIndex'] = from['rowIndex'];
                    revertAction();
                }

            } else {
                if (copy) {
                    revertAction();
                }
            }
        };

        self.assignListeners = function (scheduleId, viewOnly) {

            const scheduleTables = $('.schedule-tables');
            var scheduleElm = $(".the-schedule#" + scheduleId);
            var type = _activeViewService.viewType;


            scheduleElm.find(".all_day").off("click").on("click", function (event) {
                emitter.trigger(EVENTS.ALL_CLICKED, $(this).parents(".item-row").index());
            });

            $(".schedule-header .col-day").off("click").on("click", function (event) {
                emitter.trigger(EVENTS.DAY_CLICKED, $(this).data('day'));
            });

            scheduleElm.find(".employee-info .clickable").off("click").on("click", function (event) {
                var userId = $(this).parents(".employee-info").data("user-id");

                if (userId) {
                    emitter.trigger(EVENTS.USER_CLICKED, userId);
                }
            });

            // Handler for row checkbox (when starting copy shift mode)
            scheduleElm.find(".row-copy").off("click").on("click", function (event) {
                var rowElmIndex = $(event.target).parents(".item-row").index();

                if ($(event.target).is(":checked")) {
                   scheduleElm.find(".item:eq(" + rowElmIndex + ") .slot .copy-input:not(:checked)").click();
                }
                else {
                   scheduleElm.find(".item:eq(" + rowElmIndex + ") .slot .copy-input:checked").click();
                }

            });

            // Handler for schedule checkbox (when starting copy shift mode)
            scheduleElm.find(".schedule-copy").off("click").on("click", function (event) {
                if ($(event.target).is(":checked")) {
                    scheduleElm.find(".slot .copy-input:not(:checked)").click();
                }
                else {
                    scheduleElm.find(".slot .copy-input:checked").click();
                }
            });

            scheduleElm.find(".breaks-view-bulk-select.select-schedule").off("click").on("click", function (event) {
                if ($(event.target).is(":checked")) {
                    scheduleElm.find(".breaks-view-bulk-select.select-row:not(:checked)").click();
                }
                else {
                    scheduleElm.find(".breaks-view-bulk-select.select-row:checked").click();
                }
            });

            scheduleElm.find(".breaks-view-bulk-select.select-row").off("click").on("click", function (event) {
                var rowElmId = $(event.target).parents(".breaks-view-row").data('id');

                if ($(event.target).is(":checked")) {
                    scheduleElm.find(".breaks-view-row-" + rowElmId + " .breaks-view-bulk-select.select-shift:not(:checked)").click();
                }
                else {
                    scheduleElm.find(".breaks-view-row-" + rowElmId + " .breaks-view-bulk-select.select-shift:checked").click();
                }

            });

            let insideSlotDetails = false;

            scheduleElm.find(".grid .slot .shift-details-icon").off("mouseenter").on("mouseenter", function (event) {
                if (!action) {
                    var element = $(this);
                    insideSlotDetails = true;
                    var left = 18 + element.offset().left - element.parents(".schedule_v2").offset().left;
                    var slotDetailsPopOver = $(".slotsDetailsPopOver");
                    const slotDetailsPopOverRightEdge = 18 + element.offset().left + element.parents(".schedule_v2").offset().left + slotDetailsPopOver.outerWidth();
                    var windowWidth = $(window).width();

                    // is the popover out of the viewport
                    if (slotDetailsPopOverRightEdge > windowWidth) {
                        left -= slotDetailsPopOver.outerWidth() + 20;
                    }

                    slotDetailsPopOver.css("left", left);
                    slotDetailsPopOver.css("top", element.offset().top - element.parents(".schedule_v2").offset().top - 5);

                    var hoverAction = createAction(TYPES.OPTIONS, event);

                    slotDetailsPopOver.html("");

                    var html = _activeViewService.getSlotDetailsHTML(hoverAction);
                    slotDetailsPopOver.html(html);
                    slotDetailsPopOver.show();

                    slotDetailsPopOver
                        .off('mousemove').on('mousemove', (event) => {
                            insideSlotDetails = true;
                        })
                        .off("mouseleave").on("mouseleave", (event) => {
                            insideSlotDetails = false;
                            setTimeout(() => {
                                if (!insideSlotDetails) {
                                    $(".slotsDetailsPopOver").hide();
                                    insideSlotDetails = false;
                                }
                            }, 1000);
                        });

                    slotDetailsPopOver.find(".details-edit-shift-action").off("click").on("click", (event) => {
                        const slotId = $(event.target).data('slot-id');
                        $(`.slot#${slotId} .slot-content`).trigger('click');
                        slotDetailsPopOver.hide();
                        insideSlotDetails = false;
                    });
                }
            }).off("mouseleave").on("mouseleave", function (event) {
                insideSlotDetails = false;
                setTimeout(() => {
                    if (!insideSlotDetails) {
                        $(".slotsDetailsPopOver").hide();
                        insideSlotDetails = false;
                    }
                }, 1000);

            });

            scheduleElm.find(".graph #forecasted-hours-row").off("click").on("click", function (event) {
                emitter.trigger(EVENTS.FORECASTED_HOURS_CLICKED, scheduleId);
            });

            scheduleElm.find(".grid .slot .warnings").off("mouseenter").on("mouseenter", function (event) {

                if (!action) {
                    var element = $(event.target);

                    var conflictPopOver = $(".slotsWarningsPopOver");

                    var left = 18 + element.offset().left - element.parents(".schedule_v2").offset().left;

                    const conflictPopOverRightEdge = 18 + element.offset().left + element.parents(".schedule_v2").offset().left + conflictPopOver.outerWidth();
                    var windowWidth = $(window).width();

                    // is the popover out of the viewport
                    if (conflictPopOverRightEdge > windowWidth) {
                        left -= conflictPopOver.outerWidth() + 20;
                    }

                    conflictPopOver.css("left", left);
                    conflictPopOver.css("top", element.offset().top - element.parents(".schedule_v2").offset().top - 5);

                    var hoverAction = createAction(TYPES.OPTIONS, event);

                    conflictPopOver.html("");

                    _activeViewService.getSlotWarningHTML(hoverAction)
                        .then(function(html) {
                            conflictPopOver.html(html);
                        });

                    conflictPopOver.show();
                }

            }).off("mouseleave").on("mouseleave", function (event) {
                $(".slotsWarningsPopOver").hide();
            });

            if (_activeViewService.employeeMode) {
                scheduleElm.find(".grid .slot .warnings").off("click").on("click", function (event) {
                    var slotId = $(event.currentTarget).parents(".slot").attr('id')
                    _activeViewService.showEmployeeShiftConsentModal(slotId);
                });
                scheduleElm.find(".grid .slot .employee-reason").off("click").on("click", function (event) {
                    var slotId = $(event.currentTarget).parents(".slot").attr('id');
                    _activeViewService.showEmployeeLatenessReasonsModal(slotId);
                });
            }

            if (!viewOnly) {
                scheduleElm.find(".add-button").off("click").on("click", function (event) {

                    if (_activeViewService.isLocked) {
                        event.stopImmediatePropagation();
                        emitter.triggerSync(EVENTS.EDITS_LOCKED);
                        return;
                    }

                    emitter.trigger(EVENTS.ADD_CLICKED, scheduleId);
                });

                scheduleElm.find(".add-notes").off("click").on("click", function () {
                    if (_activeViewService.isLocked) {
                        event.stopImmediatePropagation();
                        emitter.triggerSync(EVENTS.EDITS_LOCKED);
                        return;
                    }

                    var itemIndex = $(this).parents(".item-row").index();
                    emitter.trigger(EVENTS.ADD_NOTES_CLICKED, scheduleId, itemIndex);
                });

                if (_activeViewService.isAddDayNotesEnabled) {
                    $(`.schedule-header .add-day-notes`).off("click").on("click", function (event) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        event.stopPropagation();
                        emitter.trigger(EVENTS.ADD_DAY_NOTES_CLICKED, $(this).data('date'),  $(this).find('.notes-element'));
                    });
                }

                scheduleElm.find(".remove_assignee").off("click").on("click", function (event) {

                    if (_activeViewService.isLocked) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        emitter.triggerSync(EVENTS.EDITS_LOCKED);
                        return;
                    }

                    var itemIndex = $(this).parents(".item-row").index();
                    emitter.trigger(EVENTS.ROW_REMOVE, scheduleId, itemIndex);
                });

                scheduleElm.find(".dropdown.manage-assignees-dropdown-menu").on("shown.bs.dropdown", function (event) {
                    var itemIndex = $(this).parents(".item-row").index();
                    emitter.trigger(EVENTS.DROPDOWN_CLICKED, scheduleId, itemIndex);
                });

                scheduleElm.find(".view_good_faith_estimate").off("click").on("click", function (event) {
                    var itemIndex = $(this).parents(".item-row").index();
                    emitter.trigger(EVENTS.VIEW_GFE, scheduleId, itemIndex);
                });

                scheduleElm.find(".auto-assign-with-good-faith-estimate").off("click").on("click", function (event) {
                    if (_activeViewService.isLocked) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        emitter.triggerSync(EVENTS.EDITS_LOCKED);
                        return;
                    }

                    var itemIndex = $(this).parents(".item-row").index();
                    emitter.trigger(EVENTS.AUTO_ASSIGN_WITH_GFE, scheduleId, itemIndex);
                });

                scheduleElm.find(".grid .slot .remove-job-title-slot").off("click").on("click", function (event) {
                    var optionsAction = createAction(TYPES.JOB_TITLE_SLOT, event);
                    emitter.trigger(EVENTS.REMOVE_JOB_TITLE_SLOT, optionsAction);
                    return false;
                });

                scheduleElm.find(".publish_assignee").off("click").on("click", function (event) {

                    if (_activeViewService.complianceStatus !== 'DONE') {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        return;
                    }

                    if (_activeViewService.isLocked || !_activeViewService.canPublish) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        emitter.triggerSync(EVENTS.EDITS_LOCKED);
                        return;
                    }

                    var itemIndex = $(this).parents(".item-row").index();
                    emitter.trigger(EVENTS.ROW_PUBLISH, scheduleId, itemIndex);
                });

                scheduleElm.find(".clear_assignee_shifts").off("click").on("click", function (event) {

                    if (_activeViewService.isLocked) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        emitter.triggerSync(EVENTS.EDITS_LOCKED);
                        return;
                    }

                    var itemIndex = $(this).parents(".item-row").index();
                    emitter.trigger(EVENTS.ROW_CLEAR, scheduleId, itemIndex);
                });

                scheduleElm.find(".grid .slot:not(.disabled):not(.saving):not(.extended) .slot-content").off("contextmenu").on("contextmenu", onSlotRightMenu);

                scheduleElm.find(".grid .slot:not(.disabled):not(.saving):not(.extended) .slot-drag-handler").off("mousedown").on("mousedown", slotDragHandler);

                scheduleElm.find(".grid .slot:not(.disabled):not(.saving) .slot-content").off("click").on("click", onSlotLeftClick);

                scheduleElm.find(".shift-details:not(.deactivated)").off("click").on("click", onShiftDetailsLeftClick);

                scheduleElm.find(".grid .slot:not(.disabled):not(.saving)").off("mouseenter").on("mouseenter", function (event) {
                    var addShiftBtn = $(".add-shift-btn:visible");
                    if (!addShiftBtn.length) {
                        runAddShiftBtnHandler(event);
                    }
                }).off("mouseleave").on("mouseleave", function (event) {
                    var hoverOverAddShiftBtn = $(".add-shift-btn:hover").length > 0;

                    if (!hoverOverAddShiftBtn) {
                        $('.add-shift-btn').remove();
                    }
                });

                $(".the-schedule").find(".column .col-label-container .col-label .schedule-calendar-icon").off("mouseenter").on("mouseenter", function (event) {
                    const element = $(this);
                    onScheduleCalendarHover(event, element);
                }).off("mouseleave").on("mouseleave", function (event) {
                    $(".scheduleCalendarTooltip").hide();
                });

                scheduleElm.find(".grid .slot .warnings").off("mouseenter").on("mouseenter", function (event) {

                    if (!action) {
                        var element = $(this);

                        var conflictPopOver = $(".slotsWarningsPopOver");

                        var left = 18 + element.offset().left - element.parents(".schedule_v2").offset().left;

                        const conflictPopOverRightEdge = 18 + element.offset().left + element.parents(".schedule_v2").offset().left + conflictPopOver.outerWidth();
                        var windowWidth = $(window).width();

                        // is the popover out of the viewport
                        if (conflictPopOverRightEdge > windowWidth) {
                            left -= conflictPopOver.outerWidth() + 20;
                        }

                        conflictPopOver.css("left", left);
                        conflictPopOver.css("top", element.offset().top - element.parents(".schedule_v2").offset().top - 5);

                        var hoverAction = createAction(TYPES.OPTIONS, event);

                        conflictPopOver.html("");

                        _activeViewService.getSlotWarningHTML(hoverAction)
                            .then(function(html) {
                                conflictPopOver.html(html);
                            });

                        conflictPopOver.show();
                    }

                }).off("mouseleave").on("mouseleave", function (event) {
                    $(".slotsWarningsPopOver").hide();
                });

                $('.col-warnings-result').mousemove(function () {
                    var rowsWarningsPopOver = $(".rowsWarningsPopOver:visible");
                    var element = $(this).find('.warnings');

                    if (!rowsWarningsPopOver.length && element.length) {
                        runWarningsPopOverHandler(action, element);
                    }
                });

                $('.grid .slot:not(.disabled):not(.saving)').mousemove(function (event) {
                    var addShiftBtn = $(".add-shift-btn:visible");
                    if (!addShiftBtn.length) {
                        runAddShiftBtnHandler(event);
                    }
                });

                $('.schedule_v2').on("mouseleave", ".rowsWarningsPopOver", function () {
                    offWarningsPopOverHandler();
                });

                $('.schedule_v2').on("mouseleave", function () {
                    $('.add-shift-btn').remove();
                });

                scheduleElm.find(".col-warnings-result").off("mouseenter").on("mouseenter", function (event) {
                    var element = $(this).find('.warnings');

                    if (element.length) {
                        runWarningsPopOverHandler(action, element);
                    }
                }).off("mouseleave").on("mouseleave", function (event) {
                    offWarningsPopOverHandler();
                });

                if (type != 'WEEKLY') {
                    scheduleElm.find(".grid .slot:not(.disabled):not(.extended) .resize-left").off("mousedown").on("mousedown", slotResizeLeftHandler);

                    scheduleElm.find(".grid .slot:not(.disabled):not(.extended) .resize-right").off("mousedown").on("mousedown", slotResizeRightHandler);

                    scheduleElm.find(".grid .item:not(.deactivated)").off("mousedown").on("mousedown", function(event) {

                        if (
                            _activeViewService.isLocked ||
                            (!isRightClick(event) && !_activeViewService.checkWithinEmploymentPeriod(createAction(TYPES.CLICK, event), "CREATE"))
                        ) {
                            event.preventDefault();
                            event.stopImmediatePropagation();
                            return;
                        }

                        if (!$(event.target).parents(".slot.disabled").length && !$(event.target).parents(".slot.extended").length && !action && !isRightClick(event)) {
                            action = createAction(TYPES.CREATE, event);
                            $("body").addClass("create");
                        }
                    });
                }

                var mouseScrollTimeout;

                // Auto scroll page when mousemove to the position of an event pageY
                var scrollToMouse = function (eventPageY) {

                    clearTimeout(mouseScrollTimeout);

                    if (!action) return;

                    const scrollTop = scheduleTables.scrollTop();
                    const windowHeight = $(window).height();
                    let checkAgain;

                    // Start to scroll top if mouse is < 220 pixel from the top
                    // Make sure that scroll is not already zero
                    if (scrollTop > 0 && ((eventPageY - scheduleTables.offset().top) < 220)) {
                        scheduleTables.scrollTop(scrollTop - 20);
                        checkAgain = true;
                    }
                    // Start to scroll down if mouse is < 120 pixel from the bottom
                    // Make sure that page is not fully scrolled
                    else if (eventPageY > (windowHeight - 120)) {
                        scheduleTables.scrollTop(scrollTop + 20);
                        checkAgain = true;
                    }

                    // Keep checkig again until we don't need more scroll
                    if (checkAgain) {
                        mouseScrollTimeout = setTimeout(function () {
                            scrollToMouse(eventPageY);
                        }, 30);
                    }
                };

                $(document).off("mousemove.schedule").on("mousemove.schedule", function (event) {
                    if (action) {
                        switch (action.type) {
                            case TYPES.COPY:
                            case TYPES.DRAG:
                                // Stop any previously run checks
                                clearTimeout(mouseScrollTimeout);
                                // Check if we need to update the window scroll to scroll to current mouse position
                                scrollToMouse(parseInt(event.pageY));
                                break;
                        }
                    }
                });

                scheduleElm.off("mousemove").on("mousemove", function(event) {

                    if (action) {

                        const stepWidth = _activeViewService.stepSize;

                        let minimumOffset = 0;
                        let maxVisibleLimit = _activeViewService.columnsCount * (_activeViewService.columnWidth / _activeViewService.stepPeriod);
                        let maximumOffset = maxVisibleLimit;


                        if (type == 'DAILY') {
                            if (_activeViewService.dayMaxOffLimit) {
                                maximumOffset += (_activeViewService.dayMaxOffLimit / _activeViewService.stepPeriod);
                            }

                            if (_activeViewService.dayOpenLeft) {
                                maximumOffset = maximumOffset - parseInt(_activeViewService.dayOpenLeft / _activeViewService.stepSize);
                            }

                            if (_activeViewService.dayCloseRight) {
                                maximumOffset = maximumOffset - Math.ceil(_activeViewService.dayCloseRight / _activeViewService.stepSize);
                            }
                        }

                        var ignoreX, ignoreY = false;

                        var isTemplateSlot = action.target.hasClass("template-slot");
                        var isSlotActionsDisabled = action.target.hasClass("disable-slot-actions");

                        var stepsX = (event.pageX - action['startX']) / stepWidth;

                        if (isSlotActionsDisabled) {
                            return;
                        }

                        if (isTemplateSlot && _activeViewService.viewType === 'DAILY') {
                            stepsX = 0;
                        }

                        var mouseMoveY = scheduleTables.scrollTop() + event.pageY - action['startY'];
                        var absMouseMoveY = Math.abs(mouseMoveY);
                        var slotMoveY = 0;
                        var stepsY = 0;
                        var schedule = _activeViewService.viewData.schedules[action['scheduleIndex']];

                        if (mouseMoveY > 0) {
                            for (var i = action['itemIndex']; i < schedule.rows.length; i++) {
                                for (var j = 0; j < schedule.rows[i].lines.length; j++) {

                                    if (i == action['itemIndex'] && j <= action['rowIndex']) {
                                        continue;
                                    }

                                    var line = schedule.rows[i].lines[j];
                                    var lineHeight = line.getLineHeight(j, schedule.rows[i].lines.length);

                                    if (j === (schedule.rows[i].lines.length - 1)) {
                                        lineHeight +=2;
                                    }

                                    if (absMouseMoveY > lineHeight) {
                                        stepsY++;
                                        absMouseMoveY -= lineHeight;
                                        slotMoveY += lineHeight;
                                    }
                                    else {
                                        break;
                                    }
                                }
                            }
                        }
                        else if (mouseMoveY < 0) {
                            for (var i = action['itemIndex']; i >= 0; i--) {
                                for (var j = (schedule.rows[i].lines.length - 1); j >= 0; j--) {

                                    if (i == action['itemIndex'] && j >= action['rowIndex']) {
                                        continue;
                                    }

                                    var line = schedule.rows[i].lines[j];
                                    var lineHeight = line.getLineHeight(j, schedule.rows[i].lines.length);

                                    if (j === (schedule.rows[i].lines.length - 1)) {
                                        lineHeight +=2;
                                    }

                                    if (absMouseMoveY > lineHeight) {
                                        stepsY++;
                                        absMouseMoveY -= lineHeight;
                                        slotMoveY += lineHeight;
                                    }
                                    else {
                                        break;
                                    }
                                }
                            }
                        }


                        if (mouseMoveY < 0) {
                            slotMoveY *= -1;
                            stepsY *= -1;
                        }

                        var originalOffset = action['elmStartX'] / stepWidth;
                        var originalEnd = originalOffset + (action['startWidth'] / stepWidth);

                        var roundingPolicy = Math.round;

                        if (action.type == TYPES.RESIZE) {
                            if (action.direction == 'right') {
                                roundingPolicy = Math.ceil;
                            }
                            else {
                                roundingPolicy = Math.floor;
                            }
                        }

                        originalEnd = roundingPolicy(originalEnd);
                        var offsetX = roundingPolicy(stepsX) * stepWidth;
                        var offsetY = slotMoveY;

                        switch (action.type) {

                            case TYPES.COPY:
                            case TYPES.DRAG:

                                if (event.shiftKey) {
                                    stepsX = 0;
                                    offsetX = 0;
                                }

                                var minimumXOffsetFromOriginal = minimumOffset - originalOffset;
                                var maximumXOffsetFromOriginal = maximumOffset - originalEnd ;

                                // when brand has close time extension, slot start time can't exceed max visible view
                                if ((maxVisibleLimit - originalOffset) < maximumXOffsetFromOriginal) {
                                    maximumXOffsetFromOriginal = maxVisibleLimit - originalOffset - 1;
                                }

                                if (roundingPolicy(stepsX) < minimumXOffsetFromOriginal) {
                                    offsetX = minimumXOffsetFromOriginal * stepWidth;
                                    stepsX = minimumXOffsetFromOriginal;
                                }

                                if (roundingPolicy(stepsX) > maximumXOffsetFromOriginal) {
                                    offsetX = maximumXOffsetFromOriginal * stepWidth;
                                    stepsX = maximumXOffsetFromOriginal;
                                }

                                if (offsetX != action['offsetX'] || offsetY != action['offsetY']) {

                                    action['been_moved'] = true;
                                    emitter.trigger(EVENTS.SLOT_UPDATED, $.extend({}, action));

                                    action['target'].css("top", action['elmStartY'] + offsetY + "px");

                                    // update slot time on move
                                    var newStart = action['elmStartX'] + offsetX;
                                    var newWidth = action['startWidth'] + offsetX;

                                    var newStartOffset = roundingPolicy(newStart / stepWidth);
                                    var newEndOffset = roundingPolicy((action['elmStartX'] + newWidth) / stepWidth);

                                    if (!ignoreX) {

                                        if (maxVisibleLimit !== maximumOffset) {
                                            var offViewAmount = newEndOffset - maxVisibleLimit;

                                            if (offViewAmount > 0) {
                                                action['target'].find(".slot-details").css("margin-right", `calc(${offViewAmount} * var(--step-size)`);
                                                action['target'].find(".trim-right").removeClass("hidden");
                                                action['target'].find(".shift-details-icon").addClass("with-trim");
                                            }
                                            else {
                                                action['target'].find(".slot-details").css("margin-right", `0`);
                                                action['target'].find(".trim-right").addClass("hidden");
                                                action['target'].find(".shift-details-icon").removeClass("with-trim");
                                            }
                                        }

                                        action['target'].css("left", action['elmStartX'] + offsetX + "px");

                                        _activeViewService.updateTimeOnView(action['target'], newStartOffset, newEndOffset);
                                    }

                                }
                                break;

                            case TYPES.RESIZE:
                                if (offsetX != action['offsetX'] || offsetY != action['offsetY']) {

                                    action['been_moved'] = true;
                                    emitter.trigger(EVENTS.SLOT_UPDATED, $.extend({}, action));

                                    var newStart;
                                    var newWidth;

                                    switch (action['direction']) {
                                        case 'left':
                                            if ((originalOffset + roundingPolicy(stepsX)) < minimumOffset) {
                                                stepsX = minimumOffset - originalOffset;
                                                offsetX = roundingPolicy(stepsX) * stepWidth;
                                            }

                                            if ((originalOffset + roundingPolicy(stepsX)) >= (maxVisibleLimit - 1)) {
                                                ignoreX = true;
                                            }

                                            newWidth = action['startWidth'] - offsetX;
                                            newStart = action['elmStartX'] + offsetX;
                                            break;
                                        case 'right':

                                            if ((originalEnd + roundingPolicy(stepsX)) > maximumOffset) {
                                                stepsX = maximumOffset - originalEnd;
                                                offsetX = roundingPolicy(stepsX) * stepWidth;
                                            }
                                            newWidth = action['startWidth'] + offsetX;
                                            newStart = action['elmStartX'];
                                            break;
                                    }

                                    var newStartOffset = newStart / stepWidth;
                                    var newEndOffset = (newStart + newWidth) / stepWidth;

                                    if (newWidth >= stepWidth) {
                                        action['target'].css("left", newStart + "px");
                                        action['target'].css("width", newWidth + "px");

                                        _activeViewService.updateTimeOnView(action['target'], newStartOffset, newEndOffset);
                                    }
                                    else {
                                        ignoreX = true;
                                        ignoreY = true;
                                    }
                                }
                                break;

                            case TYPES.CREATE:
                                if (offsetX != action['offsetX'] || offsetY != action['offsetY']) {
                                    var createdSlot = _activeViewService.createNewSlot(action.id, action['itemIndex'], action);

                                    _activeViewService.updateSlotTime(createdSlot);

                                    var slotHTML = _activeViewService.getSlotHTML(action.id, action['itemIndex'], createdSlot);
                                    var newSlot = $(slotHTML);

                                    $("#" + action.id).find(".item:eq(" + action['itemIndex'] + ") .slots-row:eq(" + action['rowIndex'] + ")").append(newSlot);
                                    action['target'] = newSlot;
                                    action['target'].find(".slot-drag-handler").on("mousedown", slotDragHandler);
                                    action['target'].find(".resize-left").on("mousedown", slotResizeLeftHandler);
                                    action['target'].find(".resize-right").on("mousedown", slotResizeRightHandler);

                                    action['type'] = TYPES.RESIZE;
                                    action['new'] = true;
                                    action['startWidth'] = 1 * stepWidth;

                                    action['direction'] = (offsetX > 0)? 'right': 'left';

                                    emitter.trigger(EVENTS.SLOT_UPDATED, $.extend({}, action));

                                }
                                break;
                        }

                        if (!ignoreX) {
                            action['stepsX'] = roundingPolicy(stepsX);
                            action['offsetX'] = offsetX;
                        }

                        if (!ignoreY) {
                            action['stepsY'] = roundingPolicy(stepsY);
                            action['offsetY'] = offsetY;
                        }
                    }

                });

                scheduleElm.find(".slots-row").off("dragover").on("dragover", function(event) {
                    event.preventDefault();
                });

                scheduleElm.find(".grid").off("drop").on("drop", ".item:not(.deactivated)", function(event) {
                    var newAction = createAction(TYPES.SHIFT_TEMPLATE_DROP, event.originalEvent);
                    var isShiftLocked = _activeViewService.isShiftBeforeCurrentBrandTimezone(newAction);
                    if (
                        _activeViewService.isLocked ||
                        isShiftLocked ||
                        !_activeViewService.checkWithinEmploymentPeriod(createAction(TYPES.SHIFT_TEMPLATE_DROP, event.originalEvent), "CREATE")
                    ) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        if (_activeViewService.isLocked || isShiftLocked)  {
                            emitter.triggerSync(EVENTS.EDITS_LOCKED);
                        }
                        return;
                    }

                    doActualShiftTemplateDrop(createAction(TYPES.SHIFT_TEMPLATE_DROP, event.originalEvent));
                    event.preventDefault();
                });

                scheduleElm.find(".grid").off("click").on("click", ".item:not(.deactivated)", function(event) {
                    if (
                        (
                            _activeViewService.isLocked ||
                            !_activeViewService.checkWithinEmploymentPeriod(createAction(TYPES.CLICK, event), "CREATE")
                        ) &&
                        !$(event.target).hasClass("copy-input")
                    ) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        if (_activeViewService.isLocked) {
                            emitter.triggerSync(EVENTS.EDITS_LOCKED);
                        }
                        return;
                    }

                    if (!stopRowClick && $(event.target).hasClass("slots-row")) {
                        emitter.trigger(EVENTS.ROW_CLICKED, createAction(TYPES.CLICK, event));
                    }
                });

                scheduleElm.find(".grid").off("contextmenu").on("contextmenu", ".item:not(.deactivated)", function(event) {
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    if (_activeViewService.isLocked) {
                        emitter.triggerSync(EVENTS.EDITS_LOCKED);
                        return;
                    }

                    if (!stopRowClick && ($(event.target).hasClass("slots-row") || $(event.target.parentElement).hasClass("availability-slot"))) {
                        emitter.trigger(EVENTS.ROW_RIGHT_CLICK, createAction(TYPES.ROW_OPTIONS, event));
                    }
                });

                scheduleElm.find(".grid").off("mouseup").on("mouseup", ".item:not(.deactivated)", function(event) {
                    if (action) {
                        var newAction = createAction(TYPES.CLICK, event);
                        var isShiftLocked = _activeViewService.isShiftBeforeCurrentBrandTimezone(newAction);
                        if ((action['offsetX'] || action['offsetY']) && isShiftLocked) {
                            revertAction();
                            emitter.triggerSync(EVENTS.EDITS_LOCKED);
                            return;
                        }

                        $(".active-action").removeClass("active-action");

                        switch (action.type) {
                            case TYPES.DRAG:
                                doActualMove();
                                break;
                            case TYPES.COPY:
                                doActualMove(true);
                                break;

                            case TYPES.RESIZE:
                                if (action.new) {
                                    doActualCreate();
                                }
                                else {
                                    doActualResize();
                                }
                                break;
                        }

                        if (action.type != TYPES.CREATE && action['been_moved']) {
                            stopRowClick = true;
                            setTimeout(function() {
                                stopRowClick = false;
                            }, 250);
                        }

                        action = null;
                        $("body").removeClass("drag resizeRight resizeLeft create copy");
                        $(".in-action").removeClass("in-action");
                    }

                });

                $("body").off("mouseup").on("mouseup", function(event) {
                    if (action) {

                        switch (action.type) {
                            case TYPES.DRAG:
                            case TYPES.COPY:
                                if (action['offsetX'] > action['offsetY']) {
                                    doActualMove((action.type === TYPES.COPY));
                                }
                                else {
                                    revertAction();
                                }
                                break;

                            case TYPES.RESIZE:
                                if (action.new) {
                                    doActualCreate();
                                }
                                else {
                                    doActualResize();
                                }
                                break;
                        }

                        if (action.type != TYPES.CREATE && action['been_moved']) {
                            stopRowClick = true;
                            setTimeout(function() {
                                stopRowClick = false;
                            }, 250);
                        }

                        action = null;
                        $("body").removeClass("drag resizeRight resizeLeft create");
                        $(".in-action").removeClass("in-action");
                    }

                });
            }
        };
    };

    SchedulerDragDropService.prototype.EVENTS = EVENTS;

    app.service('SchedulerDragDropService', [function () {
        return function (ViewService) {
            return new SchedulerDragDropService(ViewService);
        }
    }]);

})(angular.module('harriApp'));
